import { useContext } from "react";
import { ContentContext } from "common/providers/ContentProvider";

export const useContent = () => useContext(ContentContext);

export default useContent;
